// Package-side half of the nav-icon-inheritance feature. This package must
// never import app code (apps/backoffice depends on this package, not the
// reverse), so the actual route -> icon/color resolution
// (apps/backoffice/src/components/shell/active-nav-identity.ts) lives in the
// app and is provided here exactly once, near the routed root (a separate
// task). Default is `null` so every existing archetype test that renders
// without a Provider keeps working unchanged — no router mock required.

import { createContext, useContext, type ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export interface ActiveNavIdentity {
  Icon: LucideIcon;
  colorVar: string;
}

const ActiveNavIdentityContext = createContext<ActiveNavIdentity | null>(null);

export function ActiveNavIdentityProvider({
  value,
  children,
}: {
  value: ActiveNavIdentity | null;
  children: ReactNode;
}) {
  return (
    <ActiveNavIdentityContext.Provider value={value}>{children}</ActiveNavIdentityContext.Provider>
  );
}

/** Archetypes call this to get the current route's nav icon/color. Returns
 * null outside any Provider (isolated unit tests, Storybook) or on a route
 * the resolver doesn't recognize — both render exactly today's plain header. */
export function useActiveNavIdentity(): ActiveNavIdentity | null {
  return useContext(ActiveNavIdentityContext);
}
